// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"afa88007","455":"5a4731fd","977":"d9d93aad"}[chunkId] + ".chunk.js";
};